import React from "react";

//Styles
import "./WhyDesignContest.scss";

//Components
import { ReactComponent as HeaderMaskSvg } from "assets/how-it-works-top.svg";
import { ReactComponent as BottomLineSvg } from "assets/how-it-works-bottom.svg";
import RevealOnScroll from "common-components/RevealOnScroll/RevealOnScroll";
import Button from "common-components/Button/Button";

//Data
import { whyDCExampleData } from "./exampleData";

//SVG Circles
import { ReactComponent as Circle1 } from "assets/list-circles/1.svg";
import { ReactComponent as Circle2 } from "assets/list-circles/2.svg";
import { ReactComponent as Circle3 } from "assets/list-circles/3.svg";
import { ReactComponent as Circle4 } from "assets/list-circles/4.svg";
import { ReactComponent as Circle5 } from "assets/list-circles/5.svg";
import { ReactComponent as Circle6 } from "assets/list-circles/6.svg";

const svgCircles = [<Circle1 />, <Circle2 />, <Circle3 />, <Circle4 />, <Circle5 />, <Circle6 />];

function WhyDesignContest() {
  return (
    <section className="page-landing why-dc">
      <HeaderMaskSvg className="top-svg" />
      <RevealOnScroll>
        <h2>Why DesignContest?</h2>
      </RevealOnScroll>
      <ol className="m-width-wrapper">
        {whyDCExampleData.map(({ heading, description }, index) => (
          <RevealOnScroll key={index}>
            <li className="why-item">
              {svgCircles[index]}
              <span className="number">{index + 1}</span>
              <div className="heading-wrapper">
                <span className="heading">{heading}</span>
              </div>
              <p>{description}</p>
            </li>
          </RevealOnScroll>
        ))}
      </ol>
      <Button styleType="primary rounded">Get started</Button>
      <BottomLineSvg className="bottom-line" />
    </section>
  );
}

export default WhyDesignContest;
